import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkComponent, MediaModule } from '@spartacus/storefront';
import { SdCatalogBannerComponent } from './catalog-banner.component';

@NgModule({
  imports: [
    NgIf,
    NgTemplateOutlet,
    AsyncPipe,
    GenericLinkComponent,
    MediaModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.SdCMSCatalogBannerComponent]: {
          component: SdCatalogBannerComponent,
        },
      },
    }),
  ],
  declarations: [SdCatalogBannerComponent],
})
export class SdCatalogBannerModule {}
